import { useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import ScriptSureIframeLayout from '../../components/ScriptSure/ScriptSureIframeLayout';
import GetHelpButton from '../../components/ScriptSure/GetHelpButton';

const PatientAllergies = () => {
    const navigate = useNavigate();

    const { id: patientId = '' } = useParams();
    const [getHelpModalOpen, setGetHelpModalOpen] = useState<boolean>(false);

    return (
        <div>
            <PageTitle
                title="Patient Allergies"
                onClick={() => navigate(`/patient/${patientId}`)}
            >
                <GetHelpButton setOpen={setGetHelpModalOpen} />
            </PageTitle>
            <ScriptSureIframeLayout
                scriptSureSource={(
                    webAppUrl: string,
                    scriptSurePatientId: number,
                    scriptSureSessionToken: string,
                ) =>
                    `${webAppUrl}/widgets/allergy/${scriptSurePatientId}?sessiontoken=${scriptSureSessionToken}&darkmode=off`
                }
                getHelpModalOpen={getHelpModalOpen}
                setGetHelpModalOpen={setGetHelpModalOpen}
            />
        </div>
    );
};

export default PatientAllergies;
